import React from 'react';
import backgroundXnuup from '@/main/assets/images/login/xnuup_background.png';
import * as S from './styles';

interface IContainerScreenProps {
  children?: React.ReactNode;
  title?: string;
  hasBackground?: boolean;
  style?: React.CSSProperties;
  id?: string
  withSpacing?: boolean;
}

function ContainerScreen({
  title,
  hasBackground = false,
  withSpacing = false,
  children,
  style,
  id }: IContainerScreenProps) {
  const generatedId = id ? `${id}` : 'id-general-container-screen';
  return (
    <S.Container
      id={generatedId}
      $withSpacing={withSpacing}
      style={style ? style : {}}
    >
      {title && <S.TitleScreen>{title}</S.TitleScreen>}
      {children}
      {hasBackground && <S.BackgroundImage src={backgroundXnuup} />}
    </S.Container>
  )
}

export default ContainerScreen